module.exports = __webpack_public_path__ + "f084d4673d408346373e996c34e834cd.svg";